import { createRouter, createWebHistory } from 'vue-router'
import MenuApt from '../components/MenuApt.vue'
import Access from '../components/Access.vue'
import GenerateParcel from '../components/GenerateParcel.vue'
import PickUpPackages from '../components/PickUpPackages.vue'
import NotFound from '../components/NotFound.vue'
import Messages from '../components/Messages.vue'
import MenuService from '../components/MenuService.vue'
import ParcelList from '../components/ParcelList.vue'

const routes = [
  {
    path: '/:apm',
    name: 'MenuApt',
    component: MenuApt,
    props: true
  }, 
  {
    path: '/access/:apm',
    name: 'Access',
    component: Access,
    props: true
  },
  {
    path: '/generateParcel/:apm',
    name: 'GenerateParcel',
    component: GenerateParcel,
    props: true
  }, 
  //catchall 404 --> Cuando no exista una ruta
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:apm/:code',
    name: 'PickUpPackages',
    component: PickUpPackages,
    props: true
  },
  {
    path: '/:apm/msg',
    name: 'Messages',
    component: Messages,
    props: true
  },
  {
    path: '/menuService/:apm',
    name: 'MenuService',
    component: MenuService,
    props: true
  },
  {
    path: '/parcelList/:apm',
    name: 'ParcelList',
    component: ParcelList,
    props: true
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
